'use client';

import { useStrictContext } from '@cc-shopping/hooks/useStrictContext';
import { createContext } from 'react';
import type { PagePayload } from '../../Shibuya';

export interface AnalyticsPageViewContextValue {
  pageName: string;
  pageViewId: string;
  pageViewReady: boolean;
  contentId?: PagePayload['content_id'];
  contentSource?: PagePayload['content_source'];
}

export const AnalyticsPageViewContext = createContext<AnalyticsPageViewContextValue | null>(null);

export function useAnalyticsPageView() {
  return useStrictContext(AnalyticsPageViewContext);
}
